import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import ReviewLinksManager from '../components/admin/ReviewLinksManager';
import AnalyticsDashboard from '../components/admin/AnalyticsDashboard';
import KnowledgeBaseManager from '../components/admin/KnowledgeBaseManager';
import CrawlSourcesManager from '../components/admin/CrawlSourcesManager';

const Admin = () => {
  return (
    <div className="min-h-screen bg-background" data-testid="admin-page">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="mb-8">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-muted-foreground mb-3">
            YÖNETİM
          </p>
          <h1 className="text-4xl sm:text-5xl font-heading font-black tracking-tighter" data-testid="admin-title">
            Volt Usta Yönetim Paneli
          </h1>
        </div>

        <Tabs defaultValue="analytics" className="w-full">
          <TabsList className="mb-6 flex-wrap h-auto">
            <TabsTrigger value="analytics" data-testid="tab-analytics">Analitik</TabsTrigger>
            <TabsTrigger value="knowledge" data-testid="tab-knowledge">Bilgi Bankası</TabsTrigger>
            <TabsTrigger value="crawl" data-testid="tab-crawl">Crawl Kaynakları</TabsTrigger>
            <TabsTrigger value="reviews" data-testid="tab-reviews">İnceleme Linkleri</TabsTrigger>
          </TabsList>

          <TabsContent value="analytics">
            <AnalyticsDashboard />
          </TabsContent>

          <TabsContent value="knowledge">
            <KnowledgeBaseManager />
          </TabsContent>

          <TabsContent value="crawl">
            <CrawlSourcesManager />
          </TabsContent>

          <TabsContent value="reviews">
            <ReviewLinksManager />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Admin;
